module.exports = __webpack_public_path__ + "img/keyboard-keys-blind.b86746c0.png";